import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import { CONTRACTS } from '../apiUrls';
import { client } from '@/common-utils/libraries/axios/axios';
import contractFields from '../../fields/contractFields';
import merchantAccountFields from '../../../accounts/fields/merchantAccountFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 *
 * @returns Mapped data object
 */
function mapResponseData({ contractInfo, items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [contractFields.UUID.key]: item[contractFields.UUID.key],
            [contractFields.APPLICATION.key]: item[contractFields.APPLICATION.key],
            [contractFields.NUMBER.key]: item[contractFields.NUMBER.altKey],
            [contractFields.BANK_CODE.key]: item[contractFields.BANK_CODE.key],
            [contractFields.RANK.key]: item[contractFields.RANK.key],
            [contractFields.LABEL.key]: item[contractFields.LABEL.altKey],
            [contractFields.MERCHANT_LABEL.key]: item[contractFields.MERCHANT_LABEL.key],
            [contractFields.ADDED_AT.key]: item[contractFields.ADDED_AT.altKey],
            [contractFields.IDSA.key]: item[contractFields.IDSA.key],
            [contractFields.MCC.key]: item[contractFields.MCC.key],
            [contractFields.MERCHANT_NAME.key]: item[contractFields.MERCHANT_NAME.key],
            [contractFields.REGISTRATION_NUMBER.key]: item[contractFields.REGISTRATION_NUMBER.altKey]
        };
    });

    data.merchantDetails = {
        [merchantAccountFields.CREATED_AT.key]: contractInfo[merchantAccountFields.CREATED_AT.key],
        [merchantAccountFields.LABEL.key]: contractInfo[merchantAccountFields.LABEL.key],
        [merchantAccountFields.PROVIDER.key]: contractInfo[merchantAccountFields.PROVIDER.key],
        [merchantAccountFields.STATUS.key]: contractInfo[merchantAccountFields.STATUS.key],
        [merchantAccountFields.UPDATED_AT.key]: contractInfo[merchantAccountFields.UPDATED_AT.key],
        [merchantAccountFields.UUID.key]: contractInfo[merchantAccountFields.UUID.key]
    };
    data.items = mappedItems;
    data.totalResults = totalResults;

    return data;
}

const queryGetContracts = ({ query, merchantAccountId }, enabled) => {
    return {
        queryKey: [CONTRACTS.COLLECTION.queryKey, query, merchantAccountId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(CONTRACTS.COLLECTION.url, { contractAccessId: merchantAccountId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetContracts;